function startFromFilter() {
    'ngInject';

    return function (input, start) {
        if (input === undefined) {
            return input;
        } else {
            return input.slice(+start);
        }
    };
}

angular
    .module('BB')
    .filter('startFrom', startFromFilter);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_filters/start_from.filter.js